/** True in a browser (and jsdom); false in a Worker, Node script or SSR pass. */
export function isBrowser(): boolean {
  return "document" in globalThis;
}
